<script setup lang="ts">
import { useField } from 'vee-validate'

const props = withDefaults(
  defineProps<{
    name: string
    label?: string
    type?: string
  }>(),
  {
    type: 'text'
  }
)

const { value, errorMessage } = useField(() => props.name)
</script>

<template>
  <FormField :label="props.label" :error-message="errorMessage">
    <input v-model="value" :name="props.name" :type="props.type" />
  </FormField>
</template>
